import React from 'react';
import { Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import * as styles from './styles';

function SearchInput({ value, onChange, placeholder = 'Search publishers, leagues, brands…' }) {
    return (
        <Box sx={styles.wrapper}>
            <SearchIcon sx={styles.searchIcon} />
            <Box
                component="input"
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                aria-label="Search publishers"
                sx={styles.input}
            />
        </Box>
    );
}

export default SearchInput;
